export default __webpack_public_path__ + "static/3-de7669b62c1023e11d6eeff9b1920797.jpg";